var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 588.23 672.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f3f4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.87,168.11q123.23,0,246.46-.1c4.53,0,5.7,1,5.39,5.64-3.11,47.21-6,94.43-8.89,141.65q-3.22,52.38-6.38,104.76-4.26,68.58-8.61,137.16c-1.12,18-2.33,35.91-3.27,53.88-1.49,28.69-21.88,53.63-49.05,59.59a71.49,71.49,0,0,1-15.38,1.45c-106.82,0-213.63-.2-320.45.08-35.67.09-62-26.7-64.23-61.83q-4.38-68.83-8.65-137.66c-2.5-40.4-4.89-80.81-7.39-121.22q-4.25-68.58-8.61-137.16c-.85-13.63-1.4-27.29-2.51-40.9-.36-4.42.63-5.45,5.11-5.44Q170.64,168.22,293.87,168.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294,126.11q-125.24,0-250.48,0c-17.92,0-32.09-6.86-39.53-23.5C-6.9,78.19,4.66,46.42,35.8,42.69a84.6,84.6,0,0,1,10-.56c39.16,0,78.33-.09,117.49.08,3.75,0,5.63-1.11,7.08-4.45,2.18-5,4.78-9.87,7.36-14.71C186,7.57,199.46.3,216.5.21q77.49-.41,155,0c17.71.09,31.33,8,39.57,24.11,1.44,2.81,3.39,5.49,4.2,8.47,2.25,8.25,7.53,9.62,15.48,9.53,37.83-.46,75.66-.22,113.49-.2,13.79,0,26.06,3.78,34.77,15.21,10.55,13.84,11.72,29.34,5.21,44.81-6.61,15.72-19.74,23.77-36.69,23.83-73,.25-146,.12-219,.14Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ca4338d5bdc95f8852776251c4714635.svg";
export { ForwardRef as ReactComponent };